// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._805ULtW520f_RrlZC1Q {
	display: flex;
	flex-direction: column;
}
._805ULtW520f_RrlZC1Q > *:not(:last-child) {
		margin-bottom: 12px;
	}
.V6LfEzTTE2QcGdu_2oMv {
	background: white !important;
}
.V6LfEzTTE2QcGdu_2oMv {
	color: black;
	border-radius: 16px;
	border: 1px solid #f3f3f3;
	opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CrossChainFarmPage/FarmList/FarmList.pcss"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;AAKvB;AAHC;EACC,mBAAmB;CACpB;AAED;CACC,4BAA4B;AAK7B;AANA;CAEC,YAAY;CACZ,mBAAmB;CACnB,yBAAyB;CACzB,UAAU;AACX","sourcesContent":[".container {\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t& > *:not(:last-child) {\n\t\tmargin-bottom: 12px;\n\t}\n}\n.aprTooltip {\n\tbackground: white !important;\n\tcolor: black;\n\tborder-radius: 16px;\n\tborder: 1px solid #f3f3f3;\n\topacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `_805ULtW520f_RrlZC1Q`,
	"aprTooltip": `V6LfEzTTE2QcGdu_2oMv`
};
export default ___CSS_LOADER_EXPORT___;
